<template>
  <div class="main">
    <van-nav-bar
      right-text="试题审核"
      left-arrow
      @click-left="back"
    >
      <template #title>
        <div class="title" >
          {{ type.text }}
        </div>
      </template>
    </van-nav-bar>
    <van-loading style="text-align: center" type="spinner" v-if="loading" color="#1989fa" />
    <div class="content">
      <!-- 单选题 -->
      <single-opt v-if="data[type.value].typeid == '1' " :multiple="false" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 多选题 -->
      <single-opt v-if="data[type.value].typeid == '2'" :multiple="true" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 判断题 -->
      <true-or-false v-if="data[type.value].typeid == '3'" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 填空题 -->
      <fill-in v-if="data[type.value].typeid == '4'" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 问答题 -->
      <q-and-a v-if="data[type.value].typeid == '5'"    :data="data[type.value].PaperInfotabList" :active="curIndex" :paper-id="paperId" />
      <!-- 理解题 -->
      <comprehension v-if="data[type.value].typeid == '6'"   :paper-id="paperId" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 不定项选择题 -->
      <single-opt v-if="data[type.value].typeid == '7'" :multiple="true" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!--排序题 8-->
      <px-info v-if="data[type.value].typeid == '8'" :multiple="true" :data="data[type.value].PaperInfotabList" :active="curIndex" />
      <!-- 填空题 -->
      <fill-in v-if="data[type.value].typeid == '9'"   :data="data[type.value].PaperInfotabList" :active="curIndex" />

      <q-and-a v-if="parseInt(data[type.value].typeid==null || data[type.value].typeid=='' ? '0' : data[type.value].typeid) > 9 "    :data="data[type.value].PaperInfotabList" :active="curIndex" :paper-id="paperId" />

    </div>
    <van-row justify="space-between">
      <div style="margin: 0 auto;width:85%;">
        <van-col span="24">
          <p>课程：{{ form.kcmc }}</p>
          <p>命题人：{{ form.lrrname }}</p>
          <p>章节：{{ form.charactername }}</p>
          <p>知识点：{{ form.knowledgename }}</p>
          <p>难度系数：{{ form.degreedesc }}</p>
          <p>试题类型：{{ stlxFormat(form.stlx) }}</p>
          <p>试题性质：{{ examCharFormat(form.examChar) }}</p>
          <p>要求：{{ examSldFormat(form.examSld) }}</p>
          <p>用于笔试：{{ yybsFormat(form.yybs) }}</p>
          <p>用于机试：{{ yyjsFormat(form.yyjs) }}</p>
          <p v-if="form.examtypeid == '5'?true:false">语音答题：{{ yybsFormat(form.isvoice) }}</p>
          <p v-if="form.examtypeid == '5'?true:false">视频答题：{{ yyjsFormat(form.isvideo) }}</p>
          <p>教材：{{ form.jcxx }}</p>
        </van-col>
      </div>
    </van-row>
    <van-row justify="space-between">
      <div style="margin: 0 auto;width:90%;">
        <div style="padding-top: 10px;padding-bottom: 10px;">
          <van-radio-group v-model="form.shzt" direction="horizontal" :disabled="iscz">
            <van-radio name="1">审核通过</van-radio>
            <van-radio name="0">审核不通过</van-radio>
          </van-radio-group>
        </div>
        <div style="padding-left: 10px;padding-top: 10px;padding-bottom: 10px" v-if="form.kfzj == '1' ? true : false">
          <van-checkbox v-model="form.sfzj" shape="square" :disabled="iscz">终结流程</van-checkbox>
        </div>
        <div style="padding-top: 10px;padding-bottom: 10px">
          <van-field v-model="form.shyj" type="textarea" label="" placeholder="审核意见" :disabled="iscz" />
        </div>
        <div style="text-align: center">
          <van-button type="info" size="small" @click="stsh" :disabled="iscz">审 核</van-button>
        </div>
        <div style="height: 50px"> </div>
      </div>
    </van-row>
<!--    <van-tabbar v-model="active" active-color="#7d7e80">-->
<!--      <van-tabbar-item icon="share" @click="back">返回</van-tabbar-item>-->
<!--    </van-tabbar>-->
  </div>
</template>
<script>
  import singleOpt from './stsh/singleOpt'
  import TrueOrFalse from './stsh/trueOrFalse.vue'
  import fillIn from './stsh/fillIn.vue'
  import qAndA from './stsh/qAndA.vue'
  import PxInfo from './stsh/pxinfo.vue'
  import comprehension from './stsh/comprehension.vue'
  import sf from '../../utils/somefun.js';
  import {Dialog, Notify} from 'vant';
  import {getDicts,selectDictLabel} from "../../utils/data";

  var timectrl = sf.tc;
  export default {
    components: {
      singleOpt,
      TrueOrFalse,
      fillIn,
      qAndA,
      comprehension,
      PxInfo
    },
    data() {
      return {
        type: {
          text: '单选题',
          value: 0
        },
        curIndex: 0,
        curTotal: 0,
        loading:true,
        active: 0,
        kcmc:null,
        show: false,
        typeoption: [],
        title: '',
        data: [{PaperInfotabList:[],typename:'',typeid:''}],
        paperinfo:{},
        pcorphone:null,
        paperId:null,
        paperValue: null,
        piezf:0,
        zf:0,
        id:null,
        iscz:true,
        // 表单参数
        form: {
          resitid:null,
        },
        formsh:{
          dataid:null,
        },
        //难度
        degreeOptions:[],
        // 用于笔试字典
        yybsOptions: [],
        // 用于机试字典
        yyjsOptions: [],
        // 要求字典
        examSldOptions: [],
        // 试题类型字典
        stlxOptions: [],
        // 试题性质字典
        examCharOptions: [],
      }
    },
    created() {
      this.getdegreeList();
      this.getLiastPaperInfo();
      getDicts("dim_questions_nature").then(response => {
        this.examCharOptions = response.data;
      });
      getDicts("sys_yes_no").then(response => {
        this.yybsOptions = response.data;
      });
      getDicts("sys_yes_no").then(response => {
        this.yyjsOptions = response.data;
      });
      getDicts("dim_questions_demand").then(response => {
        this.examSldOptions = response.data;
      });
      getDicts("dim_questions_type").then(response => {
        this.stlxOptions = response.data;
      });
    },
    methods: {
      getdegreeList() {
        this.$ajax.get("/question/degree/list").then(response => {
          this.degreeOptions = response.rows;
          console.log(this.degreeOptions)
        });
      },
      /** 查询试卷试题列表 */
      getLiastPaperInfo(){
        this.id = this.$route.params.id;
        this.formsh.dataid = this.id;
        let that = this;
        this.$ajax.get("/question/infosh/"+that.id).then(response => {
          that.form = response.data;
          if(that.form.shzt === '2'){
            that.iscz = false;
          }console.log(that.form)
          let PaperInfotabList = new Array();
          PaperInfotabList.push(response.data);
          that.data = [{PaperInfotabList:PaperInfotabList,typename:response.data.examtypedesc,typeid:response.data.examtypeid}],
          that.type.text = response.data.examtypedesc;
          that.type.value = 0;
          that.loading=false;
        });
      },
      back()
      {
        this.$router.push({ name: 'stshindex'})
      },
      stsh() {
        this.$dialog.confirm({
          title: "试题审核",
          message: "确定要审核吗？",
          messageAlign: 'center'
        }).then(() => {
          if (this.form.shzt == '1' || this.form.shzt == '0') {
            this.formsh.shzt = this.form.shzt;
            this.formsh.shyj = this.form.shyj;
            this.formsh.sfzj = this.form.sfzj;
            this.$ajax.put('/question/infosh/editsh', this.formsh).then(response => {
              this.$toast('审核成功')
              this.$router.push({name: 'stshindex'})
            });
          } else {
            this.$toast('请选择审核状态')
          }
        }).catch(() => {

        })
      },
      examCharFormat(value) {
        return selectDictLabel(this.examCharOptions, value);
      },
      stlxFormat(value) {
        return selectDictLabel(this.stlxOptions, value);
      },
      examSldFormat(value) {
        return selectDictLabel(this.examSldOptions, value);
      },
      yybsFormat(value) {
        return selectDictLabel(this.yybsOptions, value);
      },
      yyjsFormat(value) {
        return selectDictLabel(this.yyjsOptions, value);
      },
    }
  }
</script>
<style lang="scss">
  .main{
    .title{
      i{
        margin-left: .1875rem;
      }
    }
    i.van-icon-clock{
      margin-right: .1875rem;
    }
    .name-num{
      margin: 0 .625rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: .0625rem dashed rgb(235, 234, 234);
      span{
        font-size: 1.875rem;
        color: #7469F8;
      }
    }
    .content{
      padding: 0 .625rem;
    }
  }
  .imgshowdiv{
    position: fixed;
    width: 100%;
    height: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    text-align: center;
    top: 0;
    left: 0;
    background-color: white;

    z-index: 555;
  }
  .facelayer {
    position: fixed;
    width: 100%;
    height: 100%;
    text-align: center;
    top: 0;
    left: 0;
    background-color: white;
    z-index: 999;
  }
  .jjclass{
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/teacherpage/stshdo.vue